<script>
  import { actions } from '../../utils/actions';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { getPath } from '../../utils/imageKit.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    image,
    headingText,
    headingLevel = 'h2',
    content,
    link = undefined,
    action = undefined,
    dataTestId = 'info-banner',
  } = $props();

  // Handle Image Setup
  const smSrc = getPath(image, { w: 48, ar: '1:1' });
  const mdSrc = getPath(image, { w: 48, ar: '1:1' }, 2);
  const lgSrc = getPath(image, { w: 80, ar: '1:1' });
  const xlSrc = getPath(image, { w: 80, ar: '1:1' }, 2);
</script>

{#if link && link.url}
  <BaseLink
    className="flex w-full py-4 pl-4 pr-1 bg-white text-sm text-gray-silver hover-hover:hover:text-blue-cerulean active:text-blue-cerulean
    relative sm:max-w-136 lg:rounded-xl sm:p-6 xl:p-8 sm:shadow-y-lg pseudo-shadow-hover active:shadow-active 
    sm:mx-auto sm:my-4 lg:my-0 sm:rounded-sm lg:h-full"
    {...link}
    {dataTestId}
  >
    <img
      class="w-12 h-12 xl:w-20 xl:h-20 object-contain"
      src={smSrc}
      alt={image.alt}
      height="48"
      width="48"
      srcset={`${smSrc} 48w, ${mdSrc} 96w, ${lgSrc} 80w, ${xlSrc} 160w`}
      sizes="(min-width: 1280px) 80px, 48px"
    />
    <div class="flex-1 pl-5 pr-2 xl:pl-8 text-blue-navy lg:flex lg:flex-col">
      <BaseHeading
        className="font-semibold text-base text-blue-dark-navy leading-tight mb-4 md:text-lg xl:text-1.5xl"
        {headingLevel}
      >
        {headingText}
      </BaseHeading>
      <div class="text-sm font-normal leading-normal md:text-base xl:text-lg">
        {@html content}
      </div>
    </div>
    <svg class="w-8 h-8 fill-current lg:hidden">
      <use xlink:href={`${SPRITESHEET_URL}#chevron-right`} />
    </svg>
  </BaseLink>
{:else}
  <button
    class="flex w-full py-4 pl-4 pr-1 bg-white text-left text-gray-silver hover-hover:hover:text-blue-cerulean active:text-blue-cerulean
    pseudo-shadow-hover relative sm:max-w-136 lg:rounded-xl sm:p-6 xl:p-8 sm:shadow-y-lg
    active:shadow-active lg:active:shadow-active sm:mx-auto sm:my-4 lg:my-0 sm:rounded-sm lg:h-full"
    data-testid={dataTestId}
    onclick={() => actions(action.event)}
  >
    <img
      class="w-12 h-12 xl:w-20 xl:h-20 object-contain"
      src={smSrc}
      alt={image.alt}
      height="48"
      width="48"
      srcset={`${smSrc} 48w, ${mdSrc} 96w, ${lgSrc} 80w, ${xlSrc} 160w`}
      sizes="(min-width: 1280px) 80px, 48px"
    />
    <div class="flex-1 pl-5 pr-2 xl:pl-8 text-blue-navy lg:flex lg:flex-col">
      <BaseHeading
        className="font-semibold text-base text-blue-dark-navy leading-tight mb-4 md:text-lg xl:text-1.5xl"
        {headingLevel}
      >
        {headingText}
      </BaseHeading>
      <div class="text-sm font-normal leading-normal md:text-base xl:text-lg">
        {@html content}
      </div>
    </div>
    <svg class="w-8 h-8 fill-current lg:hidden">
      <use xlink:href={`${SPRITESHEET_URL}#chevron-right`} />
    </svg>
  </button>
{/if}
